<div *ngIf="associatedLabels" class="label-selector" (click)="$event.stopPropagation()">
  <div class="label-selector__header">
    <span>{{ 'LABELS_MENU.LABELS_HEADER' | translate }}</span>
  </div>

  <div class="label-selector__content" fxLayout="column" fusePerfectScrollbar *ngIf="labels && labels.length">
    <div class="label-selector__content__label">
      <mat-checkbox
        *ngFor="let label of labels"
        [ngClass]="[label.color]"
        labelPosition="before"
        [checked]="isSelectedLabel(label.id)"
        (change)="addRemoveLabel($event, label)"
      >
        {{ label.name }}
      </mat-checkbox>
    </div>
  </div>

  <div fxLayout="column" fusePerfectScrollbar fxLayoutAlign="center center" *ngIf="labels && !labels.length">
    <mat-icon>label_off</mat-icon>
    <span>{{ 'LABELS_MENU.NO_LABELS' | translate }}</span>
  </div>
</div>
